// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/yxyweb/common/components/basic/carousel.less
// module id = 2944
// module chunks = 0